// extracted by mini-css-extract-plugin
module.exports = {"RatingsSecretScreen":"RatingsSecretScreen_RatingsSecretScreen__3Bpl0","tableContainer":"RatingsSecretScreen_tableContainer__uIw-7"};